import type { Component, AnimationOptions, CanvasAnimationOptions } from '@wix/thunderbolt-becky-types'
import type { FeatureRefs } from '../cssFeatures.types'
import { createCssCompNode } from '../cssCompNode'
import { envRefs, VariantRelationViewItem } from '@wix/thunderbolt-catharsis'
import { toBreakpointVariantsMap } from '../../utils/toBreakpointVariantsMap'
import { toCompVariants } from '../../utils/toCompVariants'
import { isVariantRelation } from '../../utils/variantsUtils'

function getCanvasVariations(values: Array<AnimationOptions | VariantRelationViewItem<AnimationOptions>>) {
	return values.filter(
		(effectItem) =>
			(isVariantRelation(effectItem) && (effectItem?.to as AnimationOptions).type === 'CanvasAnimationOptions') ||
			effectItem.type === 'CanvasAnimationOptions'
	) as Array<CanvasAnimationOptions | VariantRelationViewItem<CanvasAnimationOptions>>
}

export const canvas = createCssCompNode('canvas', 'canvas', {
	getDependencies: (component: Component, refs: FeatureRefs<'canvas'>) =>
		component.effectsQuery
			? {
					effectsData: refs.effectsQuery(component.effectsQuery),
					hasResponsiveLayout: refs.hasResponsiveLayout(component),
					componentViewMode: envRefs.componentViewMode,
			  }
			: null,

	toViewItem: (component, deps) => {
		if (!deps) {
			return null
		}

		const { hasResponsiveLayout, componentViewMode, effectsData } = deps

		if (!hasResponsiveLayout || componentViewMode === 'editor') {
			return null
		}

		const effects = effectsData?.values.filter((effect) => effect.type === 'CanvasAnimation')

		if (!effects?.length) {
			return null
		}

		return effects.map((effect) => {
			const canvasVariations = getCanvasVariations(effect.value.values)
			return {
				variants: toCompVariants(canvasVariations),
				data: toBreakpointVariantsMap(canvasVariations, (x) => x),
			}
		})
	},
})
